<script>
import { initValue } from '../index'

export default {
  name: 'read-number',
  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      purValue: '',
      loading: false
    }
  },
  watch: {
    value: {
      async handler (val) {
        this.purValue = await initValue(val)
        this.loading = true
      },
      immediate: true
    }
  },
  render (h) {
    return this.loading ? <read-text value={this.purValue}></read-text> : null
  }
}
</script>